import SocialMediaBar from "./socialMediaBar";
import SubscribeWidget from "./subscribeWidget";

const Footer = ({ showFullFooter = false }) => {
  const year = new Date().getFullYear();
  return (
    <div className="footer">
      {showFullFooter && (
        <div className="footer-container">
          <div className="footer-left">
            <h5>Site Links</h5>
            <ul>
              <li>
                <a href="/#">Home</a>
              </li>
              <li>
                <a href="/#about">About</a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://beingrefactored.com"
                >
                  Blog
                </a>
              </li>
              <li>
                <a href="mailto: cwhambletonbooks@gmail.com">Contact</a>
              </li>
            </ul>
            <SocialMediaBar />
          </div>
          <div className="footer-right">
            <h5>Mission</h5>
            <em>
              Exploring the boundaries of faith, truth, and imagination through
              speculative fiction, political intrigue, and thought-provoking
              nonfiction!
            </em>
            <div className="footer-subscribe">
              <SubscribeWidget showLabel={false} />
            </div>
          </div>
        </div>
      )}
      <div className="footer-bottom">
        <div className="copyright">Copyright {year} C.W. Hambleton</div>
      </div>
    </div>
  );
};

export default Footer;
